import PropTypes from 'prop-types'
import React from 'react'
import Designation from './Designation'
import { FilterResultsShape } from '../prop_shapes/FilterResultsShape'

const Designations = ({ searchState, filterResults, designations, locked, onDesignationsChange }) => {
  const isNationalDesignation =
      designation => !Object.keys(filterResults.designations_by_state).includes(designation.name)

  const designationStatus = designationName => {
    if (designations.includes(designationName)) {
      return 'selected'
    } else if (filterResults.active_designations[designationName]) {
      return 'active'
    } else {
      return 'disabled'
    }
  }

  const handleDesignationChange = designation => {
    if (locked) return
    let newDesignations
    if (designations.includes(designation)) {
      newDesignations = designations.filter(d => d !== designation)
    } else {
      newDesignations = [...designations, designation]
    }
    onDesignationsChange(newDesignations)
  }

  return (
    <>
      {
        filterResults.all_designations
          .filter(designation => isNationalDesignation(designation))
          .map(designation => (
            <Designation
              key={designation.id}
              designation={designation}
              count={filterResults.active_designations[designation.name] || 0}
              status={designationStatus(designation.name)}
              onDesignationChange={handleDesignationChange}
            />
          ))
      }
      {
        searchState &&
          filterResults.all_designations
            .filter(designation => filterResults.designations_by_state[designation.name] === searchState)
            .map(designation => (
              <Designation
                key={designation.id}
                designation={designation}
                count={filterResults.active_designations[designation.name] || 0}
                status={designationStatus(designation.name)}
                onDesignationChange={handleDesignationChange}
              />
            ))
      }
    </>
  )
}

Designations.propTypes = {
  searchState: PropTypes.string,
  filterResults: FilterResultsShape,
  designations: PropTypes.array.isRequired,
  onDesignationsChange: PropTypes.func.isRequired,
  locked: PropTypes.bool.isRequired
}

Designations.defaultProps = {
  searchState: null,
  filterResults: {
    active_segment: {},
    active_designations: {},
    active_category_ids: {},
    all_categories: [],
    all_designations: [],
    commodity_code_families: [],
    commodity_code_family_count: {},
    commodity_code_segments: {},
    commodity_code_segment_count: {},
    designations_by_state: {},
    rating_counts: {}
  }
}

export default Designations
